import { render, staticRenderFns } from "./ShippingPayment.vue?vue&type=template&id=937dad5e"
import script from "./ShippingPayment.vue?vue&type=script&lang=js"
export * from "./ShippingPayment.vue?vue&type=script&lang=js"
import style0 from "./ShippingPayment.vue?vue&type=style&index=0&id=937dad5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports